module.exports = __webpack_public_path__ + "static/startingstyle2-7195950118e3d8ebce6b34a931858e9e.mp4";